import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import 'leaflet/dist/leaflet.css'
import 'mapbox-gl/dist/mapbox-gl.css'
import './assets/main.scss'
import messages from './messages'
import injectInitialState from './utils/injectInitialState'

const getUserLocale = () => {
  const storedLang = window.localStorage.getItem('lang')
  if (storedLang) {
    return storedLang === 'Inuktitut' ? 'iu' : 'en'
  } else {
    return 'en'
  }
}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: getUserLocale(), // set locale, beware of the locale numerical separator ;-)
  fallbackLocale: 'en',
  messages // set locale messages
})
Vue.config.productionTip = false

// During pre-rendering the initial state is
// injected into the global scope, here we
// fill the store with the initial state.
if (window.__INITIAL_STATE__) store.replaceState(window.__INITIAL_STATE__)

router.beforeResolve(async (to, from, next) => {
  try {
    const components = router.getMatchedComponents(to)

    // By using `await` we make sure to wait
    // for the API request made by the `fetch()`
    // method to resolve before rendering the view.
    await Promise.all(components.map(x => x.fetch && x.fetch({ store })))

    // The `injectInitialState()` function injects
    // the current state as a global variable
    // `__INITIAL_STATE__` if the page is currently
    // pre-rendered.
    if (window.__PRERENDER_INJECTED) injectInitialState(store.state)
  } catch (error) {
    // This is the place for error handling in
    // case the API request fails for example.
    console.log(error)
  }

  return next()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
